import PUApi from './_puApi';

class PUPaymentAPI extends PUApi {
  constructor() {
    super();
  }
  controllerName = 'PUPayments';
}

export default new PUPaymentAPI();
